import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import * as constants from "../../constant";

export interface DialogData {
  heading: string;
  heading2?: string;
  content1: string;
  content2: string;
  errorText: string;
  button1Text: string;
  button2Text: string;
  showWaiting: boolean;
  showBuffering: boolean;
  // optional document upload block, shown only when showFileUpload is true
  showFileUpload?: boolean;
  fileAccept?: string;
  maxFileSizeMb?: number;
  uploadNote?: string;
}

@Component({
  selector: 'app-dialog-yes-or-no',
  templateUrl: 'dialog-yes-or-no.component.html',
  styleUrls: ['./dialog-yes-or-no.component.scss']
})

export class OpenDialogYesOrNo {
  imageType: string;
  iconString: string;
 
  constructor(
    public dialogRef: MatDialogRef<OpenDialogYesOrNo>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      // Every popup opened through this component is a decision or an acknowledgement and
      // always renders at least one button (the template needs button1Text). A backdrop
      // click or ESC used to resolve afterClosed() with undefined, which matches none of
      // the callers' branches - the popup vanished and nothing happened. Blocking both
      // leaves the buttons as the only way out. Programmatic dialogRef.close() is
      // unaffected, so the spinner/waiting popups still close from code as before.
      this.dialogRef.disableClose = true;

      this.imageType = sessionStorage.getItem(constants.POPUP_IMG_TYPE);
      if(this.imageType == constants.POPUP_IMG_TYPE_PROFILE){
        this.iconString = "../../../assets/popup-icons/id-verification.gif";
        sessionStorage.setItem(constants.POPUP_IMG_TYPE,"")
      }else if(this.imageType == constants.POPUP_IMG_TYPE_AADHAR){
        this.iconString = "../../../assets/popup-icons/aadhaar.gif";
        sessionStorage.setItem(constants.POPUP_IMG_TYPE,"")
      }else if(this.imageType == constants.POPUP_IMG_TYPE_NESL){
        this.iconString = "../../../assets/popup-icons/nesl.gif";
        sessionStorage.setItem(constants.POPUP_IMG_TYPE,"")
      }else if(this.imageType == constants.POPUP_IMG_TYPE_ACC_OPENING){
        this.iconString = "../../../assets/popup-icons/document-sucess.gif";
        sessionStorage.setItem(constants.POPUP_IMG_TYPE,"")
      }

    }
    showError:boolean = false;
    more: string = "Click here for more info" ;

    selectedFileName: string = "";
    selectedFile: File = null;
    fileError: string = "";

  // Mirrors the server-side checks so the user gets instant feedback. The server also
  // verifies the real %PDF magic bytes, so a renamed non-PDF is still rejected there.
  onFileSelected(event: any): void {
    this.fileError = "";
    this.selectedFileName = "";
    this.selectedFile = null;

    const file = event?.target?.files?.[0];
    if (!file) {
      return;
    }

    if (file.type !== "application/pdf") {
      this.fileError = "Only PDF files are allowed";
      event.target.value = "";
      return;
    }

    const maxMb = this.data.maxFileSizeMb || 5;
    if (file.size > maxMb * 1024 * 1024) {
      this.fileError = "Document size should not exceed " + maxMb + "MB";
      event.target.value = "";
      return;
    }

    this.selectedFile = file;
    this.selectedFileName = file.name;
  }

  // On an upload dialog the primary action (PROCEED) stays locked until a valid file is picked.
  isPrimaryDisabled(): boolean {
    return this.data.showFileUpload === true && !this.selectedFile;
  }

  onNo(): void {
    if (this.data.showFileUpload) {
      this.dialogRef.close({ action: "close" });
      return;
    }
    this.dialogRef.close("close");
  }
  onYes(): void {
    if (this.data.showFileUpload) {
      if (!this.selectedFile) {
        return;
      }
      this.dialogRef.close({
        action: "dontClose",
        fileName: this.selectedFileName,
        file: this.selectedFile
      });
      return;
    }
    this.dialogRef.close("dontClose");
  }

  toggleError(){
    this.showError = !this.showError;
    if (this.showError == true){
      this.more = 'Click here to hide info'
    }else{
    this.more = 'Click here for more info'
    }
  }

}